<template>
  <div>
    <section class="content-header show-print">
      <h1 v-if="item">{{ item['code'] }} {{ item['name'] }}</h1>
    </section>

    <section class="content">
      <item-show-errors :entity="'company'" :is-loading="isLoading"></item-show-errors>

      <div class="box box-primary">
        <div class="box-body">
            <company-info :item="item"></company-info>
        </div>
      </div>


        <div class="box box-primary" v-if="showHistory">
            <div class="box-header with-border">
                <h3 class="box-title">{{$t('tabs.history')}}</h3>
            </div>
            <div class="box-body">
                <history :item="item" :entity="'Company'" :path="'company'"></history>
            </div>
        </div>

        <div class="container-fluid hidden-print">
            <div class="row">
                <div class="col-md-6">
                </div>
                <div class="col-md-6">
                    <div class="pull-right">
                        <a class="btn btn-warning" target="_blank" :href="urlMap" v-if="isGranted('ROLE_COMPANY_LIST')">{{$t('map')}}</a>
                        <!-- <button type="button" class="btn btn-warning" @click="showMap = !showMap" v-if="isGranted('ROLE_COMPANY_LIST')">{{$t('map')}}</button> -->
                        <button type="button" class="btn btn-info" @click="showHistory = !showHistory" v-if="isGranted('ROLE_COMPANY_LIST')">{{$t('tabs.history')}}</button>
                        <button type="button" class="btn btn-success" @click="backToList(item)" v-if="isGranted('ROLE_COMPANY_LIST')">{{$t('back_to_list')}}</button>
                        <button type="button" class="btn btn-primary" @click="editItem(item)" v-if="isGranted('ROLE_COMPANY_UPDATE')">{{$t('edit')}}</button>
                        <button type="button" class="btn btn-danger" @click="deleteItem(item)" v-if="isGranted('ROLE_COMPANY_DELETE')">{{$t('delete')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CompanyInfo from './CompanyInfo'
import Image from '../../mixin/Image.vue'
import ItemShowActions from '../layout/ItemShowActions'
import ItemShowErrors from '../layout/errors/ItemShowErrors'
import History from '../History'
import ClientContacts from '../client/ClientContacts'

export default {
  mixins: [Image],

  data () {
    return {
      showHistory: false,
    }
  },
  components: {
    History,
    ItemShowErrors,
    CompanyInfo,
    ItemShowActions,
    ClientContacts,
  },
  computed: {
    ...mapGetters({
       isLoading: 'company/show/isLoading',
       item: 'company/show/retrieved',
       contacts: 'company/show/contacts',
       position: 'company/show/position',
    }),
    urlMap() {
      let parts = []

      if (this.item) {
        if (this.item.country) {
          parts.push(this.item.country.name)
        }

        if (this.item.city) {
          parts.push(this.item.city.name)
        }

        if (this.item.region) {
          parts.push(this.item.region)
        }

        if (this.item.street) {
          parts.push(this.item.street)
        }

        if (this.item.building) {
          parts.push(this.item.building)
        }

        if (this.item.postCode) {
          parts.push(this.item.postCode)
        }
      }

      return 'https://www.google.com/maps/place/ '  + parts.join(', ')
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'company/del/del',
      reset: 'company/show/reset',
      retrieve: 'company/show/retrieve',
      getContacts: 'company/show/getContacts',
    }),

    loadContacts () {
      this.getContacts(decodeURIComponent(this.$route.params.id))
    },

    backToList (item) {
      this.$router.push({ name: 'CompanyList' })
    },
    editItem (item) {
      this.$router.push({ name: 'CompanyUpdate', params: { id: this.item['@id'] } })
    },
    deleteItem (item) {
      if (window.confirm(this.$t('delete_are_you_sure'))) {
        this.$store.dispatch('company/del/del', item)
          .then(() => this.$router.push({ name: 'CompanyList' }))
      }
    }
  }
}
</script>
